var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.0001 18.3334C14.6025 18.3334 18.3334 14.6024 18.3334 10C18.3334 5.39765 14.6025 1.66669 10.0001 1.66669C5.39771 1.66669 1.66675 5.39765 1.66675 10C1.66675 14.6024 5.39771 18.3334 10.0001 18.3334Z","fill":"#00B16A","key":0}),React.createElement("path",{"d":"M13.8333 7.5L8.33325 12.5L5.83325 10.2273","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Success.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Success;

Success.default = Success;
